import { render, staticRenderFns } from "./rain-drain-detail.vue?vue&type=template&id=1b1cc361&scoped=true"
import script from "./rain-drain-detail.vue?vue&type=script&lang=js"
export * from "./rain-drain-detail.vue?vue&type=script&lang=js"
import style0 from "./rain-drain-detail.vue?vue&type=style&index=0&id=1b1cc361&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1cc361",
  null
  
)

export default component.exports